"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const art_layout_names_1 = __importDefault(require("./art-layout-names"));
const art_sets_backgrounds_1 = __importDefault(require("./art-sets-backgrounds"));
const tiles_1 = require("../tiles");
const oneLayouts = [
    {
        id: art_layout_names_1.default.SOLO_PORTRAIT,
        displayName: 'Solo',
        displayLayoutIndex: 2,
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.WINDOW_SINGLE,
                tiles: [
                    {
                        id: 'window_1_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_8X11,
                        normalizedFrame: {
                            x: 0.5262697022767076,
                            y: 0.27583187390542907,
                            width: 0.18651488616462347,
                            height: 0.24605954465849386
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.WINDOW_SINGLE,
                tiles: [
                    {
                        id: 'window_1_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_12X16,
                        normalizedFrame: {
                            x: 0.4754816112084063,
                            y: 0.2031523642732049,
                            width: 0.27583187390542907,
                            height: 0.36514886164623467
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.WINDOW_SINGLE,
                tiles: [
                    {
                        id: 'window_1_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_20X27,
                        normalizedFrame: {
                            x: 0.4071803852889667,
                            y: 0.13134851138353765,
                            width: 0.4343257443082312,
                            height: 0.6007005253940455
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.WINDOW_SINGLE,
                tiles: [
                    {
                        id: 'window_1_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_27X36,
                        normalizedFrame: {
                            x: 0.31523642732049034,
                            y: 0.04982486865148861,
                            width: 0.6007005253940455,
                            height: 0.8003502626970228
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SOLO_LANDSCAPE,
        displayName: 'Solo',
        displayLayoutIndex: 2,
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.ARMCHAIR,
                tiles: [
                    {
                        id: 'scene_couch_wall_1_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_11X8,
                        normalizedFrame: {
                            x: 0.30385288966725044,
                            y: 0.36252189141856395,
                            width: 0.15674255691768826,
                            height: 0.11821366024518389
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.ARMCHAIR,
                tiles: [
                    {
                        id: 'scene_couch_wall_1_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_16X12,
                        normalizedFrame: {
                            x: 0.26444833625218916,
                            y: 0.3309982486865149,
                            width: 0.23555166374781086,
                            height: 0.1777583187390543
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.ARMCHAIR,
                tiles: [
                    {
                        id: 'scene_couch_wall_1_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_27X20,
                        normalizedFrame: {
                            x: 0.19439579684763572,
                            y: 0.22854640980735552,
                            width: 0.3975481611208406,
                            height: 0.29422066549912435
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.ARMCHAIR,
                tiles: [
                    {
                        id: 'scene_couch_wall_1_1',
                        size: tiles_1.TILE_SIZES.RECTANGLE_36X27,
                        normalizedFrame: {
                            x: 0.10439579684763572,
                            y: 0.1385464098073555,
                            width: 0.6075481611208406,
                            height: 0.4542206654991243
                        }
                    }
                ]
            }
        ]
    },
    {
        id: art_layout_names_1.default.SOLO_SQUARE,
        displayName: 'Solo',
        displayLayoutIndex: 2,
        sets: [
            {
                backgroundImagePath: art_sets_backgrounds_1.default.WINDOW_SINGLE,
                tiles: [
                    {
                        id: 'square_8x8_1_1',
                        size: tiles_1.TILE_SIZES.SQUARE_8X8,
                        normalizedFrame: {
                            x: 0.5262697022767076,
                            y: 0.28633975481611207,
                            width: 0.18651488616462347,
                            height: 0.18651488616462347
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.WINDOW_SINGLE,
                tiles: [
                    {
                        id: 'square_12x12_1_1',
                        size: tiles_1.TILE_SIZES.SQUARE_12X12,
                        normalizedFrame: {
                            x: 0.4754816112084063,
                            y: 0.24168126094570927,
                            width: 0.27583187390542907,
                            height: 0.27583187390542907
                        }
                    }
                ]
            },
            {
                backgroundImagePath: art_sets_backgrounds_1.default.WINDOW_SINGLE,
                tiles: [
                    {
                        id: 'window_1_1',
                        size: tiles_1.TILE_SIZES.SQUARE_20X20,
                        normalizedFrame: {
                            x: 0.4071803852889667,
                            y: 0.16199649737302976,
                            width: 0.4343257443082312,
                            height: 0.4343257443082312
                        }
                    }
                ]
            }
        ]
    }
];
exports.default = oneLayouts;
//# sourceMappingURL=one.js.map